import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService, RegistrationService } from 'api';

import { ContactInfoCompanyProps, ContactInfoUserProps } from 'models/api';

export const saveContactInfo = createAsyncThunk(
	'registration/saveContactInfo',
	async (credentials: ContactInfoCompanyProps | ContactInfoUserProps, { rejectWithValue }) => {
		try {
			await RegistrationService.updateUser(credentials);
			return await AccountService.profile();
		} catch (e: any) {
			return rejectWithValue(e?.response.data);
		}
	},
);
